import http from "../http";
import ApiConstants from '../constants/ApiConstants';

class AuditLogService {
    static API_CONFIG = {
        module: "shift",
        currentPage: 1,
        limit: 20,
        fromDate: undefined,
        toDate: undefined
    }

    static getAuditLogs() {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.AUDIT_LOG.GET}`;
        const params = {
            currentPage: AuditLogService.API_CONFIG.currentPage,
            limit: AuditLogService.API_CONFIG.limit
        };

        if (AuditLogService.API_CONFIG.module !== "all") {
            params["module"] = AuditLogService.API_CONFIG.module;
        }

        if (AuditLogService.API_CONFIG.fromDate) {
            params["fromDate"] = AuditLogService.API_CONFIG.fromDate;
        }

        if (AuditLogService.API_CONFIG.toDate) {
            params["toDate"] = AuditLogService.API_CONFIG.toDate;
        }

        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error while fetching Audit Logs: ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default AuditLogService;
